module.exports = __webpack_public_path__ + "img/cirLight_0.4809494d.png";